<template>
  <div class="component container-fluid">
    <!-- notification failure -->
    <modal v-model="registrationFailed" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Message</strong></div>
      <div>
        <span class="fa fa-exclamation text-warning fa-lg" />
        Your request could not be submitted due to an intermittent connection issue! Please try submitting your request
        again after sometime.
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="regFailed()">
          OK
        </button>
      </div>
    </modal>
    <modal v-model="successResponse" effect="fade" width="35%">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title"><strong>Email Sent</strong></span>
      </div>
      <div>
        Request number has been successfully sent to your email id.
        <span class="fa fa-check-circle text-success fa-lg" />
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="ok" type="button" class="btn btn-sm btn-primary" @click="gotoHome">OK</button>
      </div>
    </modal>
    <help :portal="portal" class="pull-right padding-80" />
    <button class="btn btn-sm btn-primary pull-right btn-resume-draft" @click="gotoResumeDraft">
      Resume Draft Request
    </button>
    <h4 class="heading">Forgot your Request Number?</h4>
    <p>Please enter your e-mail address to get your request number.</p>
    <div v-if="failedresponse"><p class="text-danger">No request number found for this email Id.</p></div>
    <form submit.prevent>
      <div class="form-group">
        <label for="email" class="control-label">Email Address</label>
        <input id="email" v-model.trim="email" type="email" class="form-control" @blur="$v.email.$touch()" />
        <div v-if="!$v.email.required && $v.email.$error" class="text-danger">Please enter email address</div>
        <div v-if="!$v.email.email && $v.email.$error" class="text-danger">Please enter a valid email address</div>
        <div v-if="!$v.email.maxLength && $v.email.$error" class="text-danger">Allowed upto 150 characters only</div>
      </div>
      <div class="form-group action-btns">
        <button class="btn btn-sm btn-default" @click.prevent="gotoResumeDraft">Cancel</button>
        <button id="forgot" class="btn btn-sm btn-primary" @click="getRequestNumber">Submit</button>
      </div>
      <spinner ref="spinner" v-model="showSpinner" fixed size="lg" text="" />
    </form>
  </div>
</template>

<script>
import help from "@/mycfm/components/HelpInfo";
import { email, required, maxLength } from "vuelidate/lib/validators";
import { getReferenceNumber } from "@/services/endpointsService";
import spinner from "build-ui-x/src/Spinner";
import modal from "build-ui-x/src/Modal";

export default {
  components: {
    help,
    spinner,
    modal
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      email: "",
      successResponse: false,
      failedresponse: false,
      showSpinner: false,
      registrationFailed: false
    };
  },
  validations: {
    email: {
      email,
      required,
      maxLength: maxLength(150)
    }
  },
  methods: {
    regFailed() {
      this.registrationFailed = false;
      this.$router.push("/");
      window.location.reload();
    },
    getRequestNumber(e) {
      this.$v.$touch();
      e.preventDefault();

      if (this.$v.$invalid) {
        return;
      }

      this.showSpinner = true;

      getReferenceNumber(this.email)
        .then(data => {
          this.$store.dispatch("product/setReferenceNumber", data.referenceNumber);
          this.successResponse = data.success ? true : false;
          this.failedresponse = data.success ? false : true;
        })
        .catch(() => {
          this.registrationFailed = true;
        })
        .finally(() => {
          // hide spinner
          this.showSpinner = false;
        });
    },
    gotoResumeDraft() {
      this.$router.push("/resume-draft");
    },
    gotoHome() {
      this.successResponse = false;
    }
  }
};
</script>

<style lang="less" scoped>
input {
  width: 250px;
}
</style>
